import { USER_SETTINGS, UserSettings } from '@hb/shared'
import { useAuth } from '../../../store/auth'
import { useDocument } from '../useDocument'

export const useMySettings = () => {
  const authUser = useAuth(s => s.authUser)

  return useDocument<UserSettings>(USER_SETTINGS, authUser?.uid ?? null)
}
